/* ══════════════════════════════════════════════════════
   BRO MOTORS — QUICK ADD VARIANT FIX v9
   ──────────────────────────────────────────────────────
   <script src="{{ 'bro-quick-add-fix.js' | asset_url }}" defer></script>
   ══════════════════════════════════════════════════════ */
(function() {
  'use strict';

  var productCache = {};
  var broCurrentVariantId = null;

  /* ═══ INTERCEPT /cart/add fetch ═══
     The theme's JS uses fetch() to POST to /cart/add.
     We monkey-patch fetch to override the variant ID. */
  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (broCurrentVariantId && typeof url === 'string' && url.indexOf('/cart/add') > -1 && options && options.body) {
      try {
        /* Handle FormData body */
        if (options.body instanceof FormData) {
          options.body.set('id', broCurrentVariantId);
        }
        /* Handle JSON body */
        else if (typeof options.body === 'string') {
          var bodyData = JSON.parse(options.body);
          if (bodyData.id) {
            bodyData.id = parseInt(broCurrentVariantId);
            options.body = JSON.stringify(bodyData);
          }
        }
      } catch(e) {}
    }
    return originalFetch.apply(this, arguments);
  };

  /* ═══ INTERCEPT XMLHttpRequest too ═══ */
  var originalXHROpen = XMLHttpRequest.prototype.open;
  var originalXHRSend = XMLHttpRequest.prototype.send;
  var xhrUrl = '';

  XMLHttpRequest.prototype.open = function(method, url) {
    xhrUrl = url;
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    if (broCurrentVariantId && xhrUrl.indexOf('/cart/add') > -1 && body) {
      try {
        if (typeof body === 'string') {
          var data = JSON.parse(body);
          if (data.id) {
            data.id = parseInt(broCurrentVariantId);
            body = JSON.stringify(data);
          }
        } else if (body instanceof FormData) {
          body.set('id', broCurrentVariantId);
        }
      } catch(e) {}
    }
    return originalXHRSend.call(this, body);
  };

  /* ── Watch for quick-add drawers ── */
  function checkAndInit() {
    var drawers = document.querySelectorAll('.product-quick-add__content');
    drawers.forEach(function(drawer) {
      if (!drawer.dataset.broInit) {
        drawer.dataset.broInit = '1';
        preloadProduct(drawer);
        bindRadios(drawer);
      }
    });
  }

  new MutationObserver(function() {
    checkAndInit();
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function() {
    setTimeout(checkAndInit, 600);
  });

  /* ── Preload product JSON ── */
  function preloadProduct(drawer) {
    var productInfo = drawer.querySelector('product-info');
    if (!productInfo) return;
    var productUrl = productInfo.dataset.url;
    if (!productUrl) return;
    var handle = productUrl.replace('/products/', '').split('?')[0];
    getProductData(handle, function() {});

    /* Set initial variant ID */
    var idInput = drawer.querySelector('input[name="id"]');
    if (idInput) {
      broCurrentVariantId = idInput.value;
    }
  }

  /* ── Bind radio inputs ── */
  function bindRadios(drawer) {
    var radios = drawer.querySelectorAll('input[type="radio"]');
    radios.forEach(function(radio) {
      radio.addEventListener('click', function() {
        updateLegendLabels(drawer);
        onVariantChange(drawer);
      });
    });
  }

  /* ── Update legend labels ── */
  function updateLegendLabels(drawer) {
    var fieldsets = drawer.querySelectorAll('fieldset.product-form__input');
    fieldsets.forEach(function(fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      var legend = fs.querySelector('legend, .radio__legend');
      if (!legend) return;
      var valueEl = legend.querySelector('small.radio__legend__value, .radio__legend__value, [data-option-value], [data-selected-value]');
      if (valueEl) {
        valueEl.textContent = checked.value;
      }
    });
  }

  /* ── Handle variant change ── */
  function onVariantChange(drawer) {
    var productInfo = drawer.querySelector('product-info');
    if (!productInfo) return;

    var productUrl = productInfo.dataset.url;
    if (!productUrl) return;

    var handle = productUrl.replace('/products/', '').split('?')[0];
    var selectedOptions = getSelectedOptions(drawer);
    if (selectedOptions.length === 0) return;

    getProductData(handle, function(product) {
      if (!product) return;

      var variant = findVariant(product.variants, selectedOptions);
      if (!variant) return;

      /* Store globally — this is what the fetch interceptor uses */
      broCurrentVariantId = String(variant.id);

      /* Update all form inputs */
      updateFormVariant(drawer, variant);

      /* Update image */
      updateImage(drawer, variant, product);

      /* Update price */
      updatePrice(drawer, variant);

      /* Update button */
      updateAddToCartButton(drawer, variant);
    });
  }

  /* ── Update form variant ID ── */
  function updateFormVariant(drawer, variant) {
    var allIdInputs = drawer.querySelectorAll('input[name="id"]');
    allIdInputs.forEach(function(input) {
      input.value = variant.id;
      input.setAttribute('value', String(variant.id));
    });

    var vs = drawer.querySelector('variant-selects');
    if (vs) {
      var jsonScript = vs.querySelector('script[type="application/json"]');
      if (jsonScript) {
        jsonScript.textContent = JSON.stringify(variant);
      }
    }
  }

  /* ── Update image ── */
  function updateImage(drawer, variant, product) {
    var imgSrc = variant.featured_image ? variant.featured_image.src : null;
    if (!imgSrc) return;

    imgSrc = imgSrc.replace('https:', '').replace('http:', '');
    var allSlides = drawer.querySelectorAll('.product__slide');
    var found = false;
    var imgFilename = imgSrc.split('/').pop().split('?')[0].split('.')[0];

    allSlides.forEach(function(slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      var src = (img.src || img.dataset.src || '').replace('https:', '').replace('http:', '');
      var slideFilename = src.split('/').pop().split('?')[0].split('.')[0];

      if (slideFilename && imgFilename && slideFilename === imgFilename) {
        slide.classList.remove('product__slide--hidden', 'media--hidden');
        slide.style.display = 'block';
        slide.style.opacity = '1';
        slide.style.position = 'relative';
        found = true;
      } else {
        slide.style.display = 'none';
      }
    });

    if (!found) {
      var allImgs = drawer.querySelectorAll('.product__slide img, .product__photo img, .product__image img');
      var visibleImg = null;

      allImgs.forEach(function(img) {
        if (!visibleImg && (img.offsetWidth > 0 || img.offsetParent !== null)) {
          visibleImg = img;
        }
      });

      if (!visibleImg && allImgs.length > 0) {
        visibleImg = allImgs[0];
        var parentSlide = visibleImg.closest('.product__slide');
        if (parentSlide) {
          parentSlide.style.display = 'block';
          parentSlide.style.opacity = '1';
          parentSlide.style.position = 'relative';
        }
      }

      if (visibleImg) {
        var newSrc = 'https:' + imgSrc;
        if (newSrc.indexOf('width=') === -1) {
          newSrc += (newSrc.indexOf('?') > -1 ? '&' : '?') + 'width=800';
        }
        visibleImg.style.opacity = '0';
        visibleImg.style.transition = 'opacity 0.3s ease';
        setTimeout(function() {
          visibleImg.src = newSrc;
          visibleImg.srcset = '';
          visibleImg.style.opacity = '1';
        }, 150);
      }
    }
  }

  /* ── Update price ── */
  function updatePrice(drawer, variant) {
    var formatted = formatMoney(variant.price);
    var priceItem = drawer.querySelector('.price-item--regular .price-item, .price .price-item, .product__price .price-item');
    var priceEl = drawer.querySelector('.product__price .price, .product__price');

    if (priceItem) {
      priceItem.textContent = formatted;
    } else if (priceEl) {
      priceEl.textContent = formatted;
    }
  }

  /* ── Update add-to-cart button ── */
  function updateAddToCartButton(drawer, variant) {
    var btn = drawer.querySelector('button[name="add"], .product__submit__add');
    if (!btn) return;

    var btnText = btn.querySelector('.btn__text, [data-add-to-cart-text]');
    var formatted = formatMoney(variant.price);

    if (btnText) {
      btnText.textContent = 'Ajouter au panier • ' + formatted;
    }

    if (variant.available) {
      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
    } else {
      btn.disabled = true;
      if (btnText) {
        btnText.textContent = 'Épuisé';
      }
    }
  }

  /* ── Format money ── */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + '€';
  }

  /* ── Get selected options ── */
  function getSelectedOptions(drawer) {
    var options = [];
    var fieldsets = drawer.querySelectorAll('fieldset.product-form__input');

    if (fieldsets.length === 0) {
      fieldsets = drawer.querySelectorAll('.selector-wrapper');
    }

    fieldsets.forEach(function(fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) {
        options.push(checked.value);
      } else {
        var sel = fs.querySelector('select');
        if (sel && sel.value) {
          options.push(sel.value);
        }
      }
    });

    return options;
  }

  /* ── Find variant ── */
  function findVariant(variants, selectedOptions) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        var optKey = 'option' + (j + 1);
        if (v[optKey] !== selectedOptions[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  /* ── Get product JSON (cached) ── */
  function getProductData(handle, callback) {
    if (productCache[handle]) {
      callback(productCache[handle]);
      return;
    }

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        productCache[handle] = product;
        callback(product);
      })
      .catch(function() {
        callback(null);
      });
  }

  /* ── Reset variant ID when drawer closes ── */
  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('.product-quick-add__close-outer, .drawer__close');
    if (closeBtn) {
      broCurrentVariantId = null;
    }
  });

})();